export interface ApiResponse<T> {
  // API response envelope
  status: string
  message: string
  data: T
}

export interface UserGroupDto {
  _id: string
  code: string
  name: string
}

// Full user DTO as returned by the API
export interface UserProfileDto {
  id: number
  firstName: string | null
  lastName: string | null
  name: string | null
  email: string
  nationality: string
  birthDate: string
  country: string
  city: string
  phone: string
  createdAt: string
  modifiedAt: string
  createdBy: number
  modifiedBy: number
  gender: string
  landlinePhone: string
  workPhone: string
  profilePhoto: string
  profession: string
  actif: boolean
  role: number
  lastConnexionAt: string
  succursale: string
  group?: UserGroupDto[]
}

// Minimal profile used across the app
export interface UserProfile {
  id: number | string
  firstName: string | null
  lastName: string | null
  name: string | null
  email: string
  country: string
  profilePhoto: string
  city: string
  role: number | string
  profession: string,
  succursale: string,
  gender: string

}

export function mapUserDtoToProfile(dto: UserProfileDto): UserProfile {
  // Map only the fields our UI currently needs
  return {
    id: dto.id,
    firstName: dto.firstName ?? '',
    lastName: dto.lastName ?? '',
    name: dto.name ?? '',
    email: dto.email,
    profilePhoto: dto.profilePhoto,
    city: dto.city,
    country: dto.country,
    role: dto.role,
    profession: dto.profession,
    succursale: dto.succursale,
    gender: dto.gender,
  }
}
